module.exports = __webpack_public_path__ + "img/domain-05.bcfe3c14.png";